export const RoutesKeys = {
    ROOT:'/',
    HOME:'/home',
    LOGIN:'/login',
    REGISTER:'/register',
    SELECT_CLUB:'/select-club',
    SELECT_SONGS:'/select-songs',
    CLUB_SONG_LIST:'/songs-list',
    SUGGESTED_SONG_LIST:'/suggested-songs',
    MY_SONGS:'/my-songs',
    CLUBS_LIST:'/clubs-list',
    MODERATORS_LIST:'/moderators-list',
    ERROR_PAGE:'/404'
}